import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IMissingPackageDetailsPayload } from '../../../types';

/**
 * This is to track Missing Package Details from the backend.
 */
export const PACKAGE_DETAILS_QUERY_KEY = 'missing-package-details-query-key';

/**
 * This hook fetches details of missing package details.
 */
export const useMissingPackageDetailsQuery = (
  payload: IMissingPackageDetailsPayload
) => {
  const { data, isError, error, isPending, isFetching, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [PACKAGE_DETAILS_QUERY_KEY, payload.missingInventoryId],
      networkMode: 'always',
      retry: false,
      queryFn: () => INV_MGMT_SERVICE_API.getMissingPackageDetails(payload),
    });

  return {
    error,
    isError,
    data,
    isFetching,
    isPending,
    refetch,
  };
};
